import { gql, GraphQLClient, PublicApiClient } from '@tf/api';
import { createPublicSchemaId } from '@tf/utils';

export type FileInfo = {
	id: string;
	meta: {
		'@filename': string;
		'@mime': string;
		'@size': number;
		'@createdAt': string;
	};
};

export const getFilesInfo = async (objectIds: string[]): Promise<FileInfo[]> => {
	const filesQuery = objectIds
		.map((objectId, index) => {
			const [id /*, version */] = objectId.split('?');
			return `
				file${index}: get(rootFilter: {
					 id: "${id}"
				}) {
					id
					meta(path: ["/@filename", "/@mime", "/@size", "/@createdAt"])
					archetype
					kind
					schema
				}
			`;
		})
		.join('\n');

	const result: Record<string, [FileInfo]> = await GraphQLClient.getInstance().request(gql`
		query GetFiles {
			${filesQuery}
		}
	`);

	// Return in the same order as requested
	return objectIds.map((_, index) => result[`file${index}`][0]);
};

export const uploadFile = async ({
	clusterId,
	file,
}: {
	clusterId: string;
	file: File;
}): Promise<string | null> => {
	const schemaTag = 'types/general/file/form_attachment';

	const result = await GraphQLClient.getInstance().request<{
		mutate: { id: string; kind: string }[];
	}>(
		gql`
			mutation UploadFile($files: [Upload!]!) {
				mutate(
					create: [
						{
							id: "new://file"
							schema: "${createPublicSchemaId({ clusterId, schemaTag })}"
							files: $files
							upload: { _multipart_id: "file1" }
						}
					]
				) {
					id
					kind
				}
			}
		`,
		{
			// @ts-expect-error
			files: [file],
		}
	);

	// TODO: find result file by virtual id after https://linear.app/datagrid/issue/TF-1551 is implemented
	return result.mutate.find((r) => r.kind === 'form_attachment')?.id ?? null;
};

export const downloadFile = async (objectId: string) => {
	const res = await PublicApiClient.getInstance().request({
		path: `/v1/data/general_graph/object/${encodeURIComponent(objectId)}/download`,
	});
	return res.blob();
};
